import { useState, useEffect, Suspense, lazy } from 'react'; 
import { useRouter } from 'next/router';
import { useAppState } from '../context/AppState';
import classes from '../styles/Page.module.scss';

export const PdfIframe = ({ src }) => (
    <iframe
      src={`${src}#toolbar=0&navpanes=0&scrollbar=0`}
      title="MTN Terms and Conditions"
      frameBorder="0"
      allowFullScreen
    />
);
const LazyPdfIframe = lazy(() => 
  import('./mtn-terms-and-conditions') 
    .then(module => ({ default: module.PdfIframe }))
);

const Legal = () => {
  const router = useRouter();
  
  const { language, country } = useAppState(); 
  
  const [isComponentMounted, setIsComponentMounted] = useState(false); 
  const defaultPdfUrl = "/MTN Cameroon - MTN One User Terms and Conditions (1).pdf";
  let pdfSource = defaultPdfUrl; 

  useEffect(() => {
    setIsComponentMounted(true);
  }, []);

  const handleGoBack = () => {
    router.back(); 
  };

  // --- PDF Source Mapping Logic ---
   console.log('country && language', country, language)
  if (country && language) {
    
    const lang = language.toLowerCase();
    const ctry = country.toLowerCase();

    const pdfMap = {
      'en_cm': defaultPdfUrl,
      'fr_cm': "/MTN Cameroon - Conditions générales d’utilisation de MTN One (T&C's - French).pdf",
      'en_ci': '/MTN CI - MTN One User Terms and Conditions.pdf',
      'fr_ci': '/MTN CI - CGU MTN One - (T&Cs - French).pdf',
    };

    const key = `${lang}_${ctry}`;
    
    if (pdfMap[key]) {
      pdfSource = pdfMap[key];
    } else {
      pdfSource = defaultPdfUrl;
      console.warn(`No specific PDF found for key: ${key}. Using default PDF.`);
    }
  }

  const pageTitle = `MTN Legal Document: ${country?.toUpperCase() || 'Country'} (${language?.toUpperCase() || 'Language'})`;

  
  return (
    <div className={classes.oPageHome}>
      <div className={classes.oContent}>
        <h1 className={`${classes.aPageTitle}`}>
          <span
            onClick={handleGoBack}
            className={classes.backIcon}
            role="button"
            aria-label="Go back"
          >
            &#8592;
          </span>
          {pageTitle}
        </h1>
        
        {isComponentMounted && (
          <div className={classes.iframeContainer}>
            <Suspense fallback={<div>Loading legal document...</div>}>
                <LazyPdfIframe src={pdfSource} />
            </Suspense>
          </div>
        )}
      </div>
    </div>
  );
};

export default Legal;